import { FieldPath, UseFormHandleSubmit } from 'react-hook-form';

import Button from 'coreOld/components/Button';
import Field from 'coreOld/components/Field';
import Visible from 'coreOld/components/Visible';
import { Grid, WrapperBlock } from 'coreOld/elements';
import { InputType, Size } from 'coreOld/enums';
import { manufacturersService } from 'partsOld/services';
import { IManufacturer } from 'partsOld/types';

import { ButtonWrapper, divStyle, gridStyle } from './costManufacturerStyle';
import { ICostManufacturerForm, ManufacturerType } from './types';

interface IProps {
  startDate: Date;
  endDate: Date;
  onChangeDate: (date: Date, path: FieldPath<ICostManufacturerForm>) => void;
  onCheckboxChange: (tyoe: string) => void;
  manufacturerType: ManufacturerType;
  onChangeManufacturer: (value) => void;
  manufacturer: IManufacturer;
  handleSubmit: UseFormHandleSubmit<ICostManufacturerForm>;
  onNext: (data: ICostManufacturerForm) => void;
}

const CostManufacturerModalView = ({
  startDate,
  endDate,
  onChangeDate,
  onCheckboxChange,
  manufacturerType,
  manufacturer,
  onChangeManufacturer,
  handleSubmit,
  onNext,
}: IProps) => {
  return (
    <>
      <WrapperBlock style={divStyle}>
        <Grid container spacing={2}>
          <Grid item xs={12} style={gridStyle}>
            Cost Dates
          </Grid>

          <Grid item xs={6}>
            <Field
              type={InputType.DATE_INPUT}
              inputProps={{
                selected: startDate,
                startDate,
                onChange: (date) => onChangeDate(date, 'costStartDate'),
                size: Size.LG,
                showBorder: true,
                hasBorder: false,
                placeholder: 'Start Date',
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <Field
              type={InputType.DATE_INPUT}
              inputProps={{
                selected: endDate,
                minDate: startDate,
                onChange: (date) => onChangeDate(date, 'costEndDate'),
                size: Size.LG,
                showBorder: true,
                hasBorder: false,
                placeholder: 'End Date',
              }}
            />
          </Grid>
        </Grid>
      </WrapperBlock>

      <WrapperBlock style={divStyle}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Field
              type={InputType.CHECKBOX}
              inputProps={{
                label: 'Multiple manufacturers',
                checked: manufacturerType === ManufacturerType.MULTIPLE,
                value: ManufacturerType.MULTIPLE,
                onChange: (e) => onCheckboxChange(e.target.value),
              }}
            />
          </Grid>

          <Grid item xs={12}>
            <Field
              type={InputType.CHECKBOX}
              inputProps={{
                label: 'Single manufacturer',
                checked: manufacturerType === ManufacturerType.SINGLE,
                value: ManufacturerType.SINGLE,
                onChange: (e) => onCheckboxChange(e.target.value),
              }}
            />
          </Grid>

          <Visible when={manufacturerType === ManufacturerType.SINGLE}>
            <Grid item xs={6}>
              <Field
                type={InputType.ASYNC_SELECT}
                inputProps={{
                  getOptions: manufacturersService.getMany,
                  onChange: (e) => onChangeManufacturer(e),
                  getValue: (opt) => opt,
                  isClearable: false,
                  size: Size.MD,
                  value: manufacturer,
                  placeholder: 'Select a Manufacturer',
                }}
              />
            </Grid>
          </Visible>
        </Grid>
      </WrapperBlock>

      <WrapperBlock hideBorderBottom buttonWrapper>
        <ButtonWrapper>
          <Button onClick={handleSubmit(onNext)}>Next</Button>
        </ButtonWrapper>
      </WrapperBlock>
    </>
  );
};

export default CostManufacturerModalView;
